import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { FolderGlobalStore } from '../../../../../store/medicalService/folder.global-store';
import { routeParams } from '../../../../../modules/shared/shared.global-service';
import { WorkMassWorkComponent } from '../work-mass-work.component';

@Component({
    selector: 'app-work-mass-work-dialog',
    templateUrl: './work-mass-work-dialog.component.html',
    styleUrl: './work-mass-work-dialog.component.scss',
    imports: [
        WorkMassWorkComponent,
    ],
})
export class WorkMassWorkDialogComponent extends BaseDialogComponent {

    protected readonly folderStore = inject(FolderGlobalStore);

    constructor() {
        super();
        this.folderStore.setFolderId(routeParams.folderId());
        this.folderStore.setDialogComponent(this);
    }

}
